'use strict';

const SUPPLIER_UPDATE_EVENT = 'supplier-update';
const VEHICLE_UPDATE_EVENT = 'vehicle-update';

/** @type {string|null|undefined} */
let lastDispatchedSupplierHash;

/** @type {string|null|undefined} */
let lastDispatchedVehicleId;

function isLeadGenStore() {
	return globalThis.rp_app?.data?.is_lead_gen === true;
}

/**
 * Normalizes values for STEER data attributes and update events.
 *
 * @param {unknown} value
 * @returns {string|null}
 */
function normalizeSteerId(value) {
	const isNonEmptyString = typeof value === 'string' && value !== '';
	const isInteger = typeof value === 'number' && Number.isInteger(value);

	return (isNonEmptyString || isInteger) ? String(value) : null;
}

/**
 * @param {string|null} nextValue
 * @param {string|null|undefined} lastValue
 * @returns {boolean}
 */
function shouldDispatch(nextValue, lastValue) {
	return nextValue !== lastValue;
}

function dispatchSteerEvent(eventName, detail) {
	globalThis.dispatchEvent(new CustomEvent(eventName, { detail }));
}

/**
 * @param {unknown} supplierHash
 * @returns {void}
 */
function dispatchSteerSupplierUpdate(supplierHash) {
	const normalizedHash = normalizeSteerId(supplierHash);
	const cannotNotifySteer =
		!isLeadGenStore() || !shouldDispatch(normalizedHash, lastDispatchedSupplierHash);

	if (cannotNotifySteer) {
		return;
	}

	lastDispatchedSupplierHash = normalizedHash;

	dispatchSteerEvent(SUPPLIER_UPDATE_EVENT, { supplierHash: normalizedHash });
}

/**
 * @param {unknown} vehicleId
 * @returns {void}
 */
function dispatchSteerVehicleUpdate(vehicleId) {
	const normalizedVehicleId = normalizeSteerId(vehicleId);
	if (!shouldDispatch(normalizedVehicleId, lastDispatchedVehicleId)) {
		return;
	}

	lastDispatchedVehicleId = normalizedVehicleId;

	dispatchSteerEvent(VEHICLE_UPDATE_EVENT, { vehicleId: normalizedVehicleId });
}

/**
 * @param {unknown} garage
 * @returns {string|null}
 */
function getSelectedVehicleIdFromGarage(garage) {
	if (!Array.isArray(garage)) {
		return null;
	}

	const selectedCar = garage.find((car) => car.selected === true);

	return selectedCar ? normalizeSteerId(selectedCar.rp_car_id) : null;
}

/**
 * @param {unknown} garage
 * @returns {void}
 */
function notifySteerVehicleGarageUpdated(garage) {
	dispatchSteerVehicleUpdate(getSelectedVehicleIdFromGarage(garage));
}

function notifySteerSupplierCleared() {
	dispatchSteerSupplierUpdate(null);
}

function resetSteerOutboundForTests() {
	lastDispatchedSupplierHash = undefined;
	lastDispatchedVehicleId = undefined;
}

module.exports = {
	SUPPLIER_UPDATE_EVENT,
	VEHICLE_UPDATE_EVENT,
	dispatchSteerSupplierUpdate,
	dispatchSteerVehicleUpdate,
	getSelectedVehicleIdFromGarage,
	notifySteerSupplierCleared,
	notifySteerVehicleGarageUpdated,
	resetSteerOutboundForTests,
};
